module.exports = {
	"ha": "iha",
	"id": 5.7,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2019 Q1–2020 Q4",
		"lastYear": "2020",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by HSDA, Year Ending 2020 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -185,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.67441860465115,
						"dataLabels": {
							"enabled": true,
							"format": "42"
						}
					},
					{
						"y": 65.11627906976744,
						"dataLabels": {
							"enabled": true,
							"format": "28"
						}
					},
					{
						"y": 60.46511627906976,
						"dataLabels": {
							"enabled": true,
							"format": "26"
						}
					},
					{
						"y": 55.81395348837209,
						"dataLabels": {
							"enabled": true,
							"format": "24"
						}
					},
					{
						"y": 34.883720930232556,
						"dataLabels": {
							"enabled": true,
							"format": "15"
						}
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": true,
							"format": "66"
						}
					},
					{
						"y": 90.9090909090909,
						"dataLabels": {
							"enabled": true,
							"format": "60"
						}
					},
					{
						"y": 87.87878787878788,
						"dataLabels": {
							"enabled": true,
							"format": "58"
						}
					},
					{
						"y": 80.3030303030303,
						"dataLabels": {
							"enabled": true,
							"format": "53"
						}
					},
					{
						"y": 54.54545454545454,
						"dataLabels": {
							"enabled": true,
							"format": "36"
						}
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": true,
							"format": "362"
						}
					},
					{
						"y": 84.80662983425414,
						"dataLabels": {
							"enabled": true,
							"format": "307"
						}
					},
					{
						"y": 82.87292817679558,
						"dataLabels": {
							"enabled": true,
							"format": "300"
						}
					},
					{
						"y": 77.34806629834254,
						"dataLabels": {
							"enabled": true,
							"format": "280"
						}
					},
					{
						"y": 45.30386740331492,
						"dataLabels": {
							"enabled": true,
							"format": "164"
						}
					},
					{
						"y": null
					},
					{
						"y": 99.50980392156863,
						"dataLabels": {
							"enabled": true,
							"format": "203"
						}
					},
					{
						"y": 76.47058823529412,
						"dataLabels": {
							"enabled": true,
							"format": "156"
						}
					},
					{
						"y": 74.50980392156863,
						"dataLabels": {
							"enabled": true,
							"format": "152"
						}
					},
					{
						"y": 67.15686274509804,
						"dataLabels": {
							"enabled": true,
							"format": "137"
						}
					},
					{
						"y": 44.6078431372549,
						"dataLabels": {
							"enabled": true,
							"format": "91"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.3255813953488413,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.3333333333333326,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.62068965517241,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -32.07547169811321,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.193370165745856,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.28013029315961,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -41.42857142857142,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.4901960784313708,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.152709359605915,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.564102564102566,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.868421052631582,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.57664233576643,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "East Kootenay<br>n=43"
			},
			{
				"x": 9,
				"text": "Kootenay Boundary<br>n=66"
			},
			{
				"x": 15,
				"text": "Okanagan<br>n=362"
			},
			{
				"x": 21,
				"text": "Thompson Cariboo Shuswap<br>n=204"
			}
		],
		"dataTable": {
			"East Kootenay": [
				43,
				42,
				28,
				26,
				24,
				15
			],
			"Kootenay Boundary": [
				66,
				66,
				60,
				58,
				53,
				36
			],
			"Okanagan": [
				362,
				362,
				307,
				300,
				280,
				164
			],
			"Thompson Cariboo Shuswap": [
				204,
				203,
				156,
				152,
				137,
				91
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_iha_5_7.json
// module id = 240
// module chunks = 0